import { getAnswerSheetList } from '@/api/wenjuan/settlement'
import { extendObject } from '@/assets/js/utils'

// 获取列表
export function getList(params) {
  this.loading = true
  getAnswerSheetList(params)
    .then(res => {
      if (res.data.code != 0) {
        this.$message.error(res.data.msg)
        this.loading = false
        return
      }
      this.totalYuanAmount = Number(res.data.data.totalYuanAmount).toFixed(2)
      if (params.settleStatus == 0) {
        this.total = res.data.data.total
      } else {
        this.total = 0
      }
      this.page.total = res.data.data.total
      this.page.currentPage = res.data.data.current
      this.page.pageSize = res.data.data.size
      this.data = res.data.data.records
      this.data.forEach(item => {
        item.singleAmount = Number(item.singleAmount)
          ? (Number(item.singleAmount) / 100).toFixed(2)
          : Number(item.singleAmount).toFixed(2)
        item.realAmount = Number(item.realAmount)
          ? (Number(item.realAmount) / 100).toFixed(2)
          : Number(item.realAmount).toFixed(2)
        if (item.adjustAmount && item.adjustAmount != '0') {
          let sign = item.adjustAmount.substring(0, 1)
          let adjustAmountReal = item.adjustAmount.substring(1)
          item.adjustAmount = sign + (Number(adjustAmountReal) / 100).toFixed(2)
        } else {
          item.adjustAmount = ''
        }
      })
      // 如果当前查询页数 没有数据 往前一页查询一次
      if (this.data.length === 0 && this.page.currentPage != 1) {
        this.page.currentPage--
        if (this.page.currentPage > 0) {
          params.current = this.page.currentPage
          getList(params)
        }
      }
      this.loading = false
    })
    .catch(err => {
      console.log(err)
      // return err
    })
}

export const publicPage = {
  total: 0,
  currentPage: 1,
  pageSize: 20,
  pageSizes: [10, 20, 30, 50, 100],
  background: true
}
